import React, { useEffect, useState } from 'react'
import MainLayout from 'layouts/main'
import { CreateLinkedinResponse } from 'services/http/backoffice/definition/types'
import { getCountryPerceptions } from '../../../services/http/backoffice/country-perception/endpoints'
import { useFlagcardContext } from 'app/contexts/flagcard'

import backofficeDefinitionService from 'services/http/backoffice/definition/'
import { IFormValues } from './types'

import Page from '@zera-admin/page'
import { PageHeader, Row, Column } from '@zera-admin/page'
import Breadcrumb, { BreadcrumbItem } from '@zera-admin/breadcrumb'
import { RadioGroup } from '@zera-admin/radio'
import Button from '@zera-admin/button'
import Input from '@zera-admin/input'
import Textarea from '@zera-admin/textarea'
import Checkbox from '@zera-admin/checkbox'
import Select, { SelectOptionProps } from '@zera-admin/select'
import Icon from '@zera-admin/icon'
import Form, {
  FormHeader,
  FormFooter,
  FormHookSubmitProps,
  useForm,
  FormSection,
} from '@zera-admin/form'
import { ENVIRONMENT_LIST } from 'constants/environment'

function Linkedin() {
  const [formValues, setFormValues] = useState<IFormValues>({
    countryPerceptions: [],
  })
  const [flagcard] = useFlagcardContext()

  useEffect(() => {
    getCountryPerceptions()
      .then((res) => res.data.data)
      .then((res) =>
        setFormValues((state) => ({
          ...state,
          countryPerceptions: res.map((country: any) => {
            return { label: country?.description, value: country?.key }
          }),
        }))
      )
  }, [])

  const formOptions = {
    crawlingType: [
      {
        label: 'Fetch',
        value: 'fetch',
      },
      {
        label: 'Search',
        value: 'search',
      },
    ],
    definitionType: {
      fetch: [
        {
          label: 'Company',
          value: 'company',
        },
        {
          label: 'Account',
          value: 'account',
        },
      ],
      search: [
        {
          label: 'Company',
          value: 'company',
        },
        {
          label: 'Account',
          value: 'account',
        },
      ],
    },
    allowedLanguages: [
      { value: 'Turkish', label: 'Turkish' },
      { value: 'English', label: 'English' },
    ],
    allowedDbs: [
      { value: 'oracle', label: 'Oracle' },

      { value: 'neo4j', label: 'Meo4j' },
    ],
    environment: ENVIRONMENT_LIST,
    definitionBlackLists: [{ label: 'BlackListWord', value: 'BlackListWord' }],
  }

  const initialValues: CreateLinkedinResponse = {
    crawlingType: undefined,
    definitionType: undefined,
    definitionValue: undefined,
    countryPerception: 1,
    allowedLanguages: undefined,
    allowedDbs: undefined,
    useIncomingDefinition: false,
    environment: undefined,
    definitionBlackLists: undefined,
    includeAccounts: undefined,
    location: undefined,
    size: undefined,
    industries: undefined,
    locations: undefined,
  }

  const form = useForm<CreateLinkedinResponse>({
    initialValues,
    onSubmit: (props) => handlerSubmit(props),
  })

  const handlerSubmit = (
    props: FormHookSubmitProps<CreateLinkedinResponse>
  ) => {
    console.log(form.values)

    if (!props.errors) {
      if (form.values) {
        backofficeDefinitionService
          .createLinkedin(form.values)
          .then(() => {
            flagcard.add({
              appearance: 'success',
              title: 'Kayıt işlemi başarılı',
              children:
                'Girmiş olduğunuz bilgiler ile birlikte veri sisteme başarıyla kayıt edilmiştir. Dilerseniz yeni veri ekleyebilirsiniz.',
            })
            form.handleBatchUpdate(initialValues)
          })
          .catch((error) => {
            console.log(error)
            flagcard.add({
              appearance: 'error',
              title: 'Bir hata oluştu',
              children:
                'Veri eklenirken bir hata oluştu. Lütfen tekrar deneyin. Sorununuz düzelmediyse servis sağlayıcısı ile iletişime geçiniz.',
            })
          })
      }
    }
  }

  const renderDefinitionCrawlingSearch = () => {
    return (
      <>
        <Row>
          <Column xs={{ size: 12 }} md={{ size: 6 }} xl={{ size: 4 }}>
            <Input
              label="Location"
              name="locationCrawlingSearch"
              placeholder="Lokasyon Filtresi"
              onChange={(props) =>
                props.currentTarget.value.length < 1
                  ? form.handleFieldChange('location', undefined)
                  : form.handleFieldChange(
                      'location',
                      props.currentTarget.value
                    )
              }
              value={form.values?.location}
            />
          </Column>
        </Row>
        <Row>
          <Column xs={{ size: 12 }} md={{ size: 6 }} xl={{ size: 4 }}>
            <Input
              label="Size"
              name="sizeCrawlingSearch"
              placeholder="Boyut Filtresi"
              onChange={(props) =>
                props.currentTarget.value.length < 1
                  ? form.handleFieldChange('size', undefined)
                  : form.handleFieldChange('size', props.currentTarget.value)
              }
              value={form.values?.size}
            />
          </Column>
        </Row>
        <Row>
          <Column xs={{ size: 12 }} md={{ size: 6 }}>
            <Textarea
              label="Industries"
              name="industriesCrawlingSearch"
              placeholder="Endüstri filtresi girin"
              description="Birden fazla filtre için virgül (,) ile ayırın."
              value={form.values?.industries}
              onChange={(props) => {
                const values = props.currentTarget.value.split(',')
                props.currentTarget.value.length < 1
                  ? form.handleFieldChange('industries', undefined)
                  : form.handleFieldChange('industries', values)
              }}
            />
          </Column>
        </Row>
        <Row>
          <Column xs={{ size: 12 }} md={{ size: 6 }}>
            <Textarea
              label="Locations"
              name="locationsCrawlingSearch"
              placeholder="Lokasyonlar filtresi girin"
              description="Birden fazla filtre için virgül (,) ile ayırın."
              value={form.values?.locations}
              onChange={(props) => {
                const values = props.currentTarget.value.split(',')
                props.currentTarget.value.length < 1
                  ? form.handleFieldChange('locations', undefined)
                  : form.handleFieldChange('locations', values)
              }}
            />
          </Column>
        </Row>
      </>
    )
  }

  const renderDefinitionIncludeAccounts = () => {
    return (
      <Row>
        <Column xs={{ size: 12 }} xl={{ size: 6 }}>
          <Checkbox
            name="includeAccountsFetchCompany"
            label="Şirketin çalışanları da çekilsin mi?"
            onChange={(props) => {
              form.handleFieldChange(
                'includeAccounts',
                props.currentTarget.checked
              )
            }}
            defaultChecked={form.values?.includeAccounts || false}
            isChecked={form.values?.includeAccounts}
          />
        </Column>
      </Row>
    )
  }

  const renderFormContent = () => {
    return (
      <React.Fragment>
        <Form onSubmit={handlerSubmit}>
          <FormHeader
            title="Linkedin Tanımlama Formu"
            description={
              <div style={{ marginBottom: '1.5rem' }}>
                <p>Form üzerinden aşağıdaki genel bilgileri doldurunuz.</p>
                <p style={{ margin: '0', color: '#A73121' }}>
                  Doldurulması zorunlu alanlar (*) işareti ile belirtilmiştir.
                </p>
              </div>
            }
          />
          <FormSection>
            <Row>
              <Column xs={{ size: 4 }}>
                <RadioGroup
                  label="*Crawling Type"
                  name="crawlingType"
                  isRequired
                  onChange={(props) => {
                    form.handleFieldChange('definitionType', undefined)
                    form.handleFieldChange(
                      'crawlingType',
                      props.currentTarget.value
                    )
                  }}
                  options={formOptions.crawlingType}
                  value={form.values.crawlingType}
                />
              </Column>
            </Row>
            {form.values.crawlingType && (
              <Row>
                <Column xs={{ size: 4 }}>
                  <RadioGroup
                    label="*Definition Type"
                    name="definitionType"
                    isRequired
                    onChange={(props) => {
                      form.handleFieldChange(
                        'definitionType',
                        props.currentTarget.value
                      )
                    }}
                    options={
                      form.values.crawlingType === 'fetch'
                        ? formOptions.definitionType.fetch
                        : form.values.crawlingType === 'search'
                        ? formOptions.definitionType.search
                        : []
                    }
                    value={form.values.definitionType}
                  />
                </Column>
              </Row>
            )}
            <Row>
              <Column xs={{ size: 12 }} md={{ size: 6 }} xl={{ size: 4 }}>
                <Input
                  label="*Definition Value"
                  name="definitionValue"
                  placeholder={
                    form.values.crawlingType === 'fetch' &&
                    form.values.definitionType === 'keyword'
                      ? "Takip edilecek account'un universal Id 'sini girin."
                      : form.values.crawlingType === 'fetch' &&
                        form.values.definitionType === 'company'
                      ? "Takip edilecek şirket'in universal Id 'sini girin."
                      : (form.values.crawlingType === 'search' &&
                          form.values.definitionType === 'keyword') ||
                        (form.values.crawlingType === 'search' &&
                          form.values.definitionType === 'company')
                      ? "Takip edilecek keyword 'ü girin."
                      : 'Lütfen önce Definition Type seçin...'
                  }
                  isRequired
                  onChange={(props) =>
                    form.handleFieldChange(
                      'definitionValue',
                      props.currentTarget.value
                    )
                  }
                  value={form.values.definitionValue}
                />
              </Column>
            </Row>
            <Row>
              <Column xs={{ size: 12 }} md={{ size: 3 }}>
                <Select
                  label="Algı Seçiniz"
                  name="countryPerception"
                  placeholder="Seçim yapın"
                  options={formValues.countryPerceptions}
                  defaultValue={
                    formValues.countryPerceptions.find(
                      (option) => option.label === 'Türkiye'
                    ) || { label: 'Türkiye', value: 1 }
                  }
                  onChange={(props) => {
                    form.handleFieldChange(
                      'countryPerception',
                      (props as SelectOptionProps).value
                    )
                  }}
                  value={formValues.countryPerceptions.find(
                    (option) => option.value === form.values.countryPerception
                  )}
                />
              </Column>
            </Row>
            <Row>
              <Column xs={{ size: 12 }} md={{ size: 3 }}>
                <Select
                  label="Dil Seçiniz"
                  name="allowedLanguages"
                  description="*İzin verilen diller listesi"
                  placeholder="Seçim yapın"
                  isMultiple
                  options={formOptions.allowedLanguages}
                  onChange={(props) => {
                    const value = props as Array<SelectOptionProps>
                    form.handleFieldChange(
                      'allowedLanguages',
                      value.length > 0
                        ? value.map((lang) => lang.value)
                        : undefined
                    )
                  }}
                  value={form.values.allowedLanguages?.map((lang) => {
                    return { value: lang, label: lang }
                  })}
                />
              </Column>
            </Row>
            <Row>
              <Column xs={{ size: 12 }} md={{ size: 3 }}>
                <Select
                  label="Database Seçimi"
                  name="allowedDbs"
                  placeholder="Seçim yapın"
                  description="*Çekilen verilerin işlendikten sonra hangi db 'lere kaydedileceğini belirtir."
                  isMultiple
                  options={formOptions.allowedDbs}
                  onChange={(props) => {
                    const value = props as Array<SelectOptionProps>
                    form.handleFieldChange(
                      'allowedDbs',
                      value.length > 0 ? value.map((db) => db.value) : undefined
                    )
                  }}
                  value={form.values.allowedDbs?.map((db) => {
                    return { value: db.toLowerCase(), label: db }
                  })}
                />
              </Column>
            </Row>
            <Row>
              <Column xs={{ size: 12 }} md={{ size: 3 }}>
                <Select
                  label="Environment"
                  name="environment"
                  placeholder="Seçim yapın"
                  options={formOptions.environment}
                  onChange={(props) => {
                    const selectedValue = (props as SelectOptionProps).value
                    form.handleFieldChange('environment', selectedValue)
                  }}
                  value={
                    form.values.environment
                      ? [
                          {
                            label: form.values.environment,
                            value: form.values.environment,
                          },
                        ]
                      : null
                  }
                />
              </Column>
            </Row>
            <Row>
              <Column xs={{ size: 12 }} md={{ size: 3 }}>
                <Select
                  label="Definition Black Lists"
                  name="definitionBlackLists"
                  description="*Bu definition özelinde blacklist."
                  placeholder="Seçim yapın"
                  isMultiple
                  options={formOptions.definitionBlackLists}
                  onChange={(props) => {
                    const value = props as Array<SelectOptionProps>
                    form.handleFieldChange(
                      'definitionBlackLists',
                      value.length > 0
                        ? value.map((blackList) => blackList.value)
                        : undefined
                    )
                  }}
                  value={form.values.definitionBlackLists?.map((blackList) => ({
                    label: blackList,
                    value: blackList,
                  }))}
                />
              </Column>
            </Row>
            <Row>
              <Column xs={{ size: 12 }} xl={{ size: 6 }}>
                <Checkbox
                  name="useIncomingDefinition"
                  label="Bu definitiondan gelen postlar direkt olarak bu definition ile
          işaretlensin mi ?"
                  onChange={(props) => {
                    form.handleFieldChange(
                      'useIncomingDefinition',
                      props.currentTarget.checked
                    )
                  }}
                  defaultChecked={form.values?.useIncomingDefinition}
                  isChecked={form.values?.useIncomingDefinition}
                />
              </Column>
            </Row>
            {form.values.crawlingType === 'search' &&
              renderDefinitionCrawlingSearch()}
            {form.values.definitionType === 'company'
              ? renderDefinitionIncludeAccounts()
              : form.values.crawlingType === 'search' &&
                renderDefinitionIncludeAccounts()}
          </FormSection>
          <FormFooter align="start">
            <Button
              appearance="primary"
              iconBefore={<Icon name="add-item" />}
              children="Tanımlama Oluştur"
              type="submit"
            />
          </FormFooter>
        </Form>
      </React.Fragment>
    )
  }

  return (
    <MainLayout>
      <Page>
        <PageHeader
          breadcrumbs={
            <Breadcrumb>
              <BreadcrumbItem text="Anasayfa" href="/" />
              <BreadcrumbItem text="Tanımlama" href="/definition" />
              <BreadcrumbItem
                text="Tanımlama oluştur"
                href="/definition/create"
              />
              <BreadcrumbItem text="Linkedin" />
            </Breadcrumb>
          }
        />
        {renderFormContent()}
      </Page>
    </MainLayout>
  )
}

export default Linkedin
